import MarkdownComponent from 'components/shared/MarkdownComponent';
import { UIOfferWhenHighlights } from 'interfaces/ui/ui-offer-when-highlights';
import TooltipMF from '../../shared/TooltipMF';
import { StyledJobOfferLongText } from '../JobOfferLongText.styled';
import {
  StyledWhenHighlightsItem,
  StyledWhenHighlightsItemContent,
  StyledWhenHighlightsItemExtra,
  StyledWhenHighlightsItemIcon,
  StyledWhenHighlightsItemTitle,
  StyledWhenHighlightsItemValue
} from './WhenHighlightsItem.styled';

const WhenHighlightsItem = ({
  highlights,
  migratedToMarkdown
}: {
  migratedToMarkdown: boolean;
  highlights: UIOfferWhenHighlights;
}) => {
  const HighlightsItem = (
    <StyledWhenHighlightsItem tabIndex={0}>
      <StyledWhenHighlightsItemIcon
        src={highlights.icon}
        width={64}
        height={64}
      />
      <StyledWhenHighlightsItemContent>
        <StyledWhenHighlightsItemTitle>
          {highlights.title}
        </StyledWhenHighlightsItemTitle>
        <StyledWhenHighlightsItemValue>
          {highlights.value}
        </StyledWhenHighlightsItemValue>
        {highlights.extra && (
          <StyledWhenHighlightsItemExtra>
            {highlights.extra}
          </StyledWhenHighlightsItemExtra>
        )}
      </StyledWhenHighlightsItemContent>
    </StyledWhenHighlightsItem>
  );

  return (
    <>
      {highlights.tooltip && (
        <TooltipMF
          content={
            <>
              {migratedToMarkdown ? (
                <StyledJobOfferLongText>
                  <MarkdownComponent content={highlights.tooltip || ''} />
                </StyledJobOfferLongText>
              ) : (
                <span
                  dangerouslySetInnerHTML={{ __html: highlights.tooltip || '' }}
                ></span>
              )}
            </>
          }
        >
          {HighlightsItem}
        </TooltipMF>
      )}
      {!highlights.tooltip && HighlightsItem}
    </>
  );
};

export default WhenHighlightsItem;
